import React from 'react';
import { Outlet } from 'react-router-dom';

const ChanceMngPage = () => {
  return <Outlet />;
};

export default ChanceMngPage;
